import React from 'react';
import PropTypes from 'prop-types';
import * as S from "./BabySteps.Style"
import { ReactComponent as SuccessCheck } from "../../../../assets/images/habitacional/success-check.svg";
import { ReactComponent as IconError } from "../../../../assets/images/habitacional/rounded-warning.svg";

const BabySteps = ({ Steps }) => {

    const getIconForStep = (completed, pending, id) => {
        if (pending === true) {
            return <IconError style={{ color: "#ffff" }} />;
        }
        if (completed === true) {
            return <SuccessCheck />;
        }
        return id;
    }

    return (
        <S.Container>
            {Steps.reduce((acc, { step, id, label, completed, pending }) => {
                acc.push(
                    <S.Step
                        active={step}
                        isPreviousCompleted={completed}
                        key={id}
                        name={label}
                    >
                        <S.StepNumber active={step} isPreviousCompleted={completed} pending={pending}>
                            {getIconForStep(completed, pending, id)}
                        </S.StepNumber>
                        <S.StepLabel active={step}>{label}</S.StepLabel>
                    </S.Step>
                );
                return acc;
            }, [])}
        </S.Container>
    );
};

export default BabySteps;

BabySteps.propTypes = {
    Steps: PropTypes.arrayOf(
        PropTypes.shape({
            step: PropTypes.bool.isRequired,
            completed: PropTypes.bool,
            label: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
            pending: PropTypes.bool
        })
    ).isRequired
}
